/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Users_Nousers2Inputs */

const en_usermanagement_users_nousers2 = /** @type {(inputs: Usermanagement_Users_Nousers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have no associated users in your current portfolio`)
};

/**
* | output |
* | --- |
* | "You have no associated users in your current portfolio" |
*
* @param {Usermanagement_Users_Nousers2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_users_nousers2 = /** @type {((inputs?: Usermanagement_Users_Nousers2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Users_Nousers2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_users_nousers2(inputs)
});
export { usermanagement_users_nousers2 as "userManagement_users_noUsers" }